import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { Tooltip } from "../Tooltip/Tooltip.js";
/* empty css               */
import { useEffect, useRef, useState } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/components/CopyButton/CopyButton.tsx
/**
* Copies `value` to the clipboard: a small bordered button that says "Copied" for 1.4s
* afterwards (the user ID in an expanded user row). The result is announced.
*/
function CopyButton({ value, label = "Copy", copiedLabel = "Copied", failedLabel = "Copy failed", timeout = 1400, size = "sm", iconOnly = false, onCopy, onError, onClick, className, ...rest }) {
	const [state, setState] = useState("idle");
	const timer = useRef(void 0);
	useEffect(() => () => clearTimeout(timer.current), []);
	const show = (next) => {
		clearTimeout(timer.current);
		setState(next);
		timer.current = setTimeout(() => setState("idle"), timeout);
	};
	const copy = async () => {
		try {
			if (!navigator.clipboard) throw new Error("The clipboard is not available");
			await navigator.clipboard.writeText(value);
			show("copied");
			onCopy?.(value);
		} catch (error) {
			show("failed");
			onError?.(error);
		}
	};
	const text = state === "copied" ? copiedLabel : state === "failed" ? failedLabel : label;
	const icon = state === "copied" ? "check" : state === "failed" ? "alert-circle" : "copy";
	const button = /* @__PURE__ */ jsxs("button", {
		type: "button",
		...rest,
		"aria-label": iconOnly ? label : void 0,
		className: cx("ds-copy-button", `ds-copy-button--${size}`, iconOnly && "ds-copy-button--icon-only", state !== "idle" && `ds-copy-button--${state}`, className),
		onClick: (event) => {
			onClick?.(event);
			if (!event.defaultPrevented) copy();
		},
		children: [/* @__PURE__ */ jsx(Icon, { name: icon }), !iconOnly && /* @__PURE__ */ jsx("span", {
			className: "ds-copy-button__label",
			children: text
		})]
	});
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [iconOnly ? /* @__PURE__ */ jsx(Tooltip, {
		content: state === "idle" ? label : text,
		describes: false,
		children: button
	}) : button, /* @__PURE__ */ jsx("span", {
		className: "ds-copy-button__status",
		role: "status",
		children: state === "idle" ? "" : text
	})] });
}
//#endregion
export { CopyButton };

//# sourceMappingURL=CopyButton.js.map